const ITEMS = [
  "Compensado comum",
  "Compensado resinado",
  "Naval plastificado",
  "Construção civil",
  "Assoalhos para containers",
  "Baú e carretas",
  "Preço direto da fábrica",
  "Manaus – AM",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center font-display text-3xl font-black uppercase tracking-tight sm:text-5xl">
        <span className="px-6 sm:px-10">{t}</span>
        <svg viewBox="0 0 24 24" className="h-6 w-6 sm:h-8 sm:w-8 animate-[spin_8s_linear_infinite]" fill="#0c0a09" aria-hidden="true">
          <path d="M12 0l2 4 4-2-1 4.5 4.5-.5-2.5 4 4 2-4 2 2.5 4-4.5-.5 1 4.5-4-2-2 4-2-4-4 2 1-4.5-4.5.5 2.5-4-4-2 4-2-2.5-4 4.5.5-1-4.5 4 2z" />
          <circle cx="12" cy="12" r="3" fill="#FACC15" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative overflow-hidden border-y-4 border-[#0c0a09] bg-[#FACC15] py-5 text-[#0c0a09]" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
